export default __webpack_public_path__ + "static/media/ReactJS.df6e66cf.png";